module.exports = __webpack_public_path__ + "static/media/add other certificate.527fcc8f.svg";